import { render, staticRenderFns } from "./orderNumberExport.vue?vue&type=template&id=1877c23a&scoped=true"
import script from "./orderNumberExport.vue?vue&type=script&lang=js"
export * from "./orderNumberExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1877c23a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1877c23a')) {
      api.createRecord('1877c23a', component.options)
    } else {
      api.reload('1877c23a', component.options)
    }
    module.hot.accept("./orderNumberExport.vue?vue&type=template&id=1877c23a&scoped=true", function () {
      api.rerender('1877c23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/expressAndlargOrder/orderNumberExport.vue"
export default component.exports